module.exports = __webpack_public_path__ + "img/Elon-Musk.8f300957.jpg";